import type { AiSelfieArt } from "../services/aiSelfieArtService";
import {
  readSelectedAiSelfieArtFromStorage,
  readStationDataFromStorage,
} from "../services/stylePromptResolver";

function readSelectedStationFromStorage(): { name?: string } | null {
  try {
    const raw = localStorage.getItem("selectedStation");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function resolveArtDisplayName(options?: {
  selectedArt?: Partial<AiSelfieArt> | null;
  stationData?: { name?: string } | null;
  fallback?: string;
}): string {
  const { selectedArt, stationData, fallback = "Selfie Station" } = options ?? {};
  const art = selectedArt || readSelectedAiSelfieArtFromStorage();
  const selectedStation = readSelectedStationFromStorage();
  const storedStationData = readStationDataFromStorage();

  return (
    // art?.category?.name ||
    art?.name ||
    selectedStation?.name ||
    stationData?.name ||
    storedStationData?.name ||
    fallback
  );
}
